import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';

// The misses screen: the reader's misses of the last 30 days, classified.
// One column of sections, bound to this screen's slot: the top bar every
// rail screen shares ("Misses", no period), then the last 30 days in a tinted
// band labelled "Last 30 days" (`dashboard.band` over `misses.period`), as on
// the stage screens (2026-10-10). The band's cards and table are plugin
// `shared-mistakes`'s, on `misses.period`. Its rail
// entry sits in the "mistakes" section, after Blunders.
const bind = { sections: 'misses.sections' };

// Phosphor crosshair (regular): a chance not taken.
const CROSSHAIR = 'M232,120h-8.34A96.14,96.14,0,0,0,136,32.34V24a8,8,0,0,0-16,0v8.34A96.14,96.14,0,0,0,32.34,120H24a8,8,0,0,0,0,16h8.34A96.14,96.14,0,0,0,120,223.66V232a8,8,0,0,0,16,0v-8.34A96.14,96.14,0,0,0,223.66,136H232a8,8,0,0,0,0-16Zm-96,87.6V200a8,8,0,0,0-16,0v7.6A80.15,80.15,0,0,1,48.4,136H56a8,8,0,0,0,0-16H48.4A80.15,80.15,0,0,1,120,48.4V56a8,8,0,0,0,16,0V48.4A80.15,80.15,0,0,1,207.6,120H200a8,8,0,0,0,0,16h7.6A80.15,80.15,0,0,1,136,207.6ZM128,88a40,40,0,1,0,40,40A40,40,0,0,0,128,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,152Z';

export function setup(app: PiletApi) {
  app.registerPage('/misses', () => <app.Extension name="layout" params={{ layout: 'misses', bind }} />);
  app.registerExtension('rail.entries', () => null, { id: 'misses', title: 'Misses', to: '/misses', icon: CROSSHAIR, order: 45, section: 'mistakes' });
  // The top bar: "Misses" and Sync; the band below names the period.
  app.registerExtension('misses.sections', () => <app.Extension name="shared.dashboardHeader" params={{ screen: 'Misses', period: null }} />, { order: 1 });
  // The band: `shared-mistakes`'s section (cards, then the table) on `misses.period`.
  app.registerExtension('misses.sections', () => <app.Extension name="dashboard.band" params={{ slot: 'misses.period' }} />, { order: 2 });
}
